var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canDetail || _vm.canEdit || _vm.canDelete || _vm.hasDefaultSlot
    ? _c(
        _vm.tag,
        { tag: "component", staticClass: "actions" },
        [
          _vm.hasActions
            ? [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-main dropdown-toggle m-0",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuColumnActions",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(`${_vm.dropdownTitle}`)) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { "aria-labelledby": "dropdownMenuColumnActions" },
                    },
                    [
                      _vm._l(_vm.filteredActions, function (action, aIndex) {
                        return [
                          action.divider == "before"
                            ? _c("div", { staticClass: "dropdown-divider" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              key: `column-action-${_vm.index}-${aIndex}`,
                              staticClass:
                                "dropdown-item d-flex align-items-center text-left text-sm w-100",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  action.fn
                                    ? action.fn(
                                        action.id,
                                        _vm.row,
                                        _vm.fnSearch
                                      )
                                    : () => {
                                        return false
                                      }
                                },
                              },
                            },
                            [
                              action.icon
                                ? _c("i", { class: action.icon })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v(_vm._s(_vm.$t(action.text))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          action.divider == "after"
                            ? _c("div", { staticClass: "dropdown-divider" })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            : [
                _c(
                  "ul",
                  {
                    staticClass:
                      "list-group list-group-horizontal list-unstyled justify-content-end",
                    class: _vm.listClass,
                  },
                  [
                    _vm._t("default", null, {
                      confirm: _vm.confirm,
                      formatMsg: _vm.formatMsg,
                    }),
                    _vm._v(" "),
                    _vm.routeEdit && (_vm.canDetail || _vm.canEdit)
                      ? _c(
                          "li",
                          { staticClass: "list-group-item" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeEdit,
                                    params: { id: _vm.row[_vm.keyProperty] },
                                    query: _vm.routeEditQuery,
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas action",
                                  class: [
                                    _vm.canEdit
                                      ? "fa-pencil-alt edit"
                                      : "fa-eye view",
                                  ],
                                  attrs: { title: _vm.translatedEditTitle },
                                }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canDelete
                      ? _c("li", { staticClass: "list-group-item" }, [
                          _c("i", {
                            staticClass: "far fa-trash-alt action delete",
                            attrs: { title: _vm.translatedDeleteTitle },
                            on: {
                              click: function ($event) {
                                _vm.confirm(
                                  _vm.deleteItem,
                                  _vm.row[_vm.keyProperty],
                                  _vm.index,
                                  _vm.formatMsg(_vm.deleteMsgTemplate)
                                )
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }